import Apify from '@module/apify';

export default Apify({
  getApiGrants: {
    path: '/api/v4/api-grants',
  },

  removeApiGrant: {
    path: '/api/v4/api-grants/{apiGrantId}',
    pathExt: true,
    method: 'DELETE',
  },
});
